import FragmentSupportingSwitch from './frag-switch';

export {FragmentSupportingSwitch as Switch};